<template>
  <div>
    <div class="course_header">
      <video-player
        class="video-player vjs-custom-skin"
        ref="videoPlayer"
        :playsinline="true"
        :options="playerOptions"
      ></video-player>
    </div>
    <div class="course_list">
      <h3>課程列表</h3>
      <ul>
        <li 
          v-for="(item,index) in courseRes.tshCourseKpointList" 
          :key="item.kpiont_id"
          @click="fnToCourseDetails(item.kpiont_id)"
          :class="['little_hand',{'current':item.kpiont_id==kpiont_id}]"
        >
          <span>【{{index+1}}】{{item.name}}</span>
          <i class="el-icon-video-play"></i>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'

export default {
  data() {
    return{
      kpiont_id:'',
      courseRes:{},
      courseDetailsRes:{},
      feeList:[
        {
          name:'',
          price:0,
          description:'需要購買才能解鎖更多課程',
        }
      ],
      playerOptions: {
        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "", //这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
            src: "", //url地址
          },
        ],
        poster: "", //你的封面地址
        width: "800px", //播放器宽度
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true, //全屏按钮
        },
      },
    }
  },
  computed:{
    ...mapState(['user_id','validToken','isPc']),
    // qrCodeImg(){
    //   return 'https://api2.ts960.com/jehc-web-app/api/v2/QRcode/createQRcode?url=https://api2.ts960.com/wechatxh/html/association-file-details.html?cunpan_id=' + this.$route.params.id
    // },
    // payCode(){
    //   return `https://api2.ts960.com/jehc-web-app/api/v2/QRcode/createQRcode?url=${this.code_url}`
    // }
  },
  methods: {
    async getCourseDetails() {
      const { data: res } = await this.$http.get(`/api/v2/course/${this.$route.params.course_id}?user_id=${this.user_id}`);
      // console.log(res);
      this.courseRes = res.data;
      this.feeList[0].price=res.data.current_price
    },
    async fnGetCourseItem() {
      const { data: res } = await this.$http.get(`/api/v2/course/kpiont/${this.kpiont_id}?user_id=${this.user_id}`);
      // console.log(res);
      // this.courseDetailsRes = res.data;
      this.playerOptions.sources[0].src = res.data.video_url;
    },
    fnToCourseDetails(kpiont_id){
      this.kpiont_id=kpiont_id
      this.fnGetCourseItem()
    }
  },
  created(){
    this.kpiont_id=this.$route.params.kpiont_id
    this.getCourseDetails()
    this.fnGetCourseItem()
  }
}
</script>

<style lang="less" scoped>
  .course_header{
    margin: auto;
    // display: flex;
    // justify-content: center;
    padding: 30px;
    // background: #333132;
  }
  .course_list{
    background: #fff;
    width: 860px;
    margin: 27px auto 60px;
    padding: 16px 25px 27px 14px;
    h3{
      font-weight: 600;
      font-size: 22px;
      color: #333;
    }
    li{
      font-size: 18px;
      color: #999;
      border-bottom: 1px solid #f3f5f7;
      padding: 25px 0 23px;
      display: flex;
      justify-content: space-between;
      i{
        font-size: 26px;
      }
    }
    .current{
      color: #4f4e95;
    }
  }
  .video-player {
    width: 800px;
    height: 100%;
    display: block;
    margin: auto;
  }
@media screen and (max-width: 768px){
  .course_header{
    padding: 0;
  }
  .video-player {
    width: 100%;
    display: block;
    margin: auto;
  }
  .course_list{
    width: 100%;
    box-sizing: border-box;
  }
}
</style>

